<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useAccount } from 'dashboard/composables/useAccount';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const { currentAccount, updateAccount } = useAccount();

const isEnabled = ref(false);

watch(
  currentAccount,
  () => {
    const { allow_agents_view_all_conversations } =
      currentAccount.value?.settings || {};

    isEnabled.value = !!allow_agents_view_all_conversations;
  },
  { deep: true, immediate: true }
);

const updateAccountSettings = async () => {
  try {
    await updateAccount({
      allow_agents_view_all_conversations: isEnabled.value,
    });
    useAlert(
      t('GENERAL_SETTINGS.FORM.AGENT_CONVERSATION_VISIBILITY.API.SUCCESS')
    );
  } catch (error) {
    useAlert(
      t('GENERAL_SETTINGS.FORM.AGENT_CONVERSATION_VISIBILITY.API.ERROR')
    );
  }
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.AGENT_CONVERSATION_VISIBILITY.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.AGENT_CONVERSATION_VISIBILITY.NOTE')"
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch v-model="isEnabled" @change="updateAccountSettings" />
      </div>
    </template>
  </SectionLayout>
</template>
